import React, {Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import ApiForm from "../ApiForm/ApiForm";
import {createApiKey} from '../../../actions/actionDevloper';

class CreateApi extends Component {
    constructor (props){
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="mt-4">
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Api Key</strong>
                                </CardHeader>
                                <ApiForm
                                    createApi={this.props.createApiKey}/>
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


export default connect(state =>
        ({
            apis: state.develop.apis || [],
        }),
dispatch =>
    ({
        createApiKey: (data) => dispatch(createApiKey(data))
    }))(CreateApi);

